<proffeo-ui-page-wrapper>
  @if (user()) {
    <div class="profile-page">
      @if (showDetails() || showSettings()) {
        <header class="profile-toolbar">
          <button
            (click)="returnToProfile()"
            [disabled]="$safeNavigationMigration(basicData()?.editMode())"
            [attr.aria-label]="'user-profile.back' | translate"
            type="button"
            class="profile-back"
          >
            <img
              src="assets/user-profile/chevron-back.svg"
              alt=""
            />
          </button>
          <h1>{{ (showSettings() ? 'user-profile.settings' : 'user-profile.details') | translate }}</h1>
          <proffeo-ui-avatar
            [initials]="initials()"
            [readonly]="true"
            [ariaLabel]="fullName()"
            size="sm"
            borderType="none"
          />
        </header>
        @if (showSettings()) {
          <proffeo-user-profile-settings />
        } @else {
          <proffeo-user-basic-data-view />
        }
      } @else {
        <section class="profile-overview">
          <header class="profile-identity">
            <proffeo-ui-avatar
              [initials]="initials()"
              [readonly]="true"
              [ariaLabel]="fullName()"
              size="xl"
              borderType="none"
              class="profile-avatar"
            />
            <h1>{{ fullName() }}</h1>
          </header>
          <nav
            [attr.aria-label]="'user-profile-page.title' | translate"
            class="profile-navigation"
          >
            <a
              [routerLink]="profileRoute"
              [queryParams]="{ section: 'details' }"
              class="profile-row"
            >
              <img
                src="assets/user-profile/person.svg"
                alt=""
              />
              <span>{{ 'user-profile.details' | translate }}</span>
              <img
                src="assets/user-profile/chevron-forward.svg"
                alt=""
              />
            </a>
            @for (section of sections; track section.id; let index = $index) {
              @if (index === 1) {
                <a
                  [routerLink]="reportsRoute"
                  class="profile-row"
                >
                  <img
                    src="assets/user-profile/time.svg"
                    alt=""
                  />
                  <span>{{ 'user-profile.time-reports' | translate }}</span>
                  <img
                    src="assets/user-profile/chevron-forward.svg"
                    alt=""
                  />
                </a>
              }
              @if (section.id === 'settings') {
                <a
                  [routerLink]="profileRoute"
                  [queryParams]="{ section: 'settings' }"
                  class="profile-row"
                >
                  <img
                    src="assets/user-profile/settings.svg"
                    alt=""
                  />
                  <span>{{ 'user-profile.settings' | translate }}</span>
                  <img
                    src="assets/user-profile/chevron-forward.svg"
                    alt=""
                  />
                </a>
              } @else {
                <button
                  [matTooltip]="'user-profile-page.section-not-available' | translate"
                  type="button"
                  aria-disabled="true"
                  class="profile-row profile-row-unavailable"
                >
                  <img
                    [src]="'assets/user-profile/' + section.icon + '.svg'"
                    alt=""
                  />
                  <span>{{ 'user-profile.' + section.key | translate }}</span>
                  <img
                    src="assets/user-profile/chevron-forward.svg"
                    alt=""
                  />
                  <span class="profile-sr-only">{{ 'user-profile-page.section-not-available' | translate }}</span>
                </button>
              }
            }
          </nav>
          <a
            [routerLink]="signOutRoute"
            class="profile-sign-out"
          >
            {{ 'layout-user-sign-out' | translate }}
          </a>
        </section>
      }
    </div>
  }
</proffeo-ui-page-wrapper>
